import ReactDOM from 'react-dom/client';
import { Tooltip } from 'react-tooltip';

export const initTooltips = () => {
  const node = document.body.appendChild(document.createElement('div'));
  const root = ReactDOM.createRoot(node);
  root.render(
    <>
      <Tooltip
        id="sku-copy"
        style={{ zIndex: 10000 }}
        afterHide={(p) => {
          const nodes = document.querySelectorAll('span.sku');
          nodes.forEach(
            (node) =>
              (node.dataset.tooltipContent =
                'Нажмите чтобы скопировать артикул'),
          );
        }}
      />
      <Tooltip id="sku-copied" />
    </>,
  );

  window.editTooltip = (tooltipId) => {
    const node = document.getElementById(tooltipId);
    node.dataset.tooltipContent = 'Артикул скопирован';
  };
};
